import { render } from "./GroupEditComponent.vue?vue&type=template&id=287bf680&scoped=true"
import script from "./GroupEditComponent.vue?vue&type=script&lang=js"
export * from "./GroupEditComponent.vue?vue&type=script&lang=js"

import "./GroupEditComponent.vue?vue&type=style&index=0&id=287bf680&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287bf680"]])

export default __exports__